import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import userService from "./userService";

const initialState = {
    user: {},
    users: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: "",
};

// Create new practitioner profile
export const createUser = createAsyncThunk(
    "users/create",
    async (data, thunkAPI) => {
        try {
         
            return await userService.createUser(
                data
            );
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

// Get practitioner profiles
export const getUsers = createAsyncThunk(
    'users/getAll',
    async (_,
        thunkAPI) => {
        try {
            return await userService.getUser()
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    })


    export const userSlice = createSlice({
        name: "userSlice",
        initialState,
        reducers: {
            reset: (state) => initialState,
        },
        extraReducers: (builder) => {
            builder
                .addCase(createUser.pending, (state) => {
                    state.isLoading = true
                })
                .addCase(createUser.fulfilled, (state, action) => {
                    state.isLoading = false
                    state.isSuccess = true
                })
                .addCase(createUser.rejected, (state, action) => {
                    state.isLoading = false
                    state.isError = true
                    state.message = action.payload
                })
                .addCase(getUsers.pending, (state) => {
                    state.isLoading = true
                })
                .addCase(getUsers.fulfilled, (state, action) => {
                    state.isLoading = false
                    state.isSuccess = true
                    state.users = action.payload
                })
                .addCase(getUsers.rejected, (state, action) => {
                    state.isLoading = false
                    state.isError = true
                    state.message = action.payload
                })
        }
    });
    
export const { reset } = userSlice.actions;
export default userSlice.reducer;
    